import axiosInstance from '@/utils/api.js'

var state = {
  users: [],
  usersCount: [],
  usersList: [],
  fullInfoUsers: [],
  user: []
}

var getters = {
  USERS: (state) => {
    return state.users
  },
  USERS_COUNT: (state) => {
    return state.usersCount
  },
  USERS_LIST: (state) => {
    return state.usersList
  },
  FULL_INFO_USERS: (state) => {
    return state.fullInfoUsers
  },
  USER: (state) => {
    return state.user
  }
}

var mutations = {
  SET_USERS: (state, payload) => {
    state.users = payload
  },
  SET_USERS_COUNT: (state, payload) => {
    state.usersCount = payload
  },
  SET_USERS_LIST: (state, payload) => {
    state.usersList = payload
  },
  SET_FULL_INFO_USERS: (state, payload) => {
    state.fullInfoUsers = payload
  },
  SET_USER: (state, payload) => {
    state.user = payload
  }
}

var actions = {
  GET_USER: async (context, payload) => {
    let result = await axiosInstance.get('/users?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_USER', result.data)
    }
  },
  USERS_SEARCH: async (context, payload) => {
    let result = await axiosInstance.post('/users/search', payload)
    if (result.status === 200) {
      context.commit('SET_USERS', result.data)
    }
  },
  GET_FULL_INFO_USERS: async (context, payload) => {
    let result = await axiosInstance.get('/users/full_info?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_FULL_INFO_USERS', result.data)
    }
  },
  GET_USERS_COUNT: async (context, payload) => {
    let result = await axiosInstance.get('/users/users_count?is_card=' + payload)
    if (result.status === 200) {
      context.commit('SET_USERS_COUNT', result.data)
    }
  },
  GET_USERS_LIST: async (context, payload) => {
    let result = await axiosInstance.get('/users/users_list?is_card=' + payload.isCard + '&to=' + payload.to + '&from=' + payload.from)
    if (result.status === 200) {
      context.commit('SET_USERS_LIST', result.data)
    }
  },
  DELETE_USERS: (context, payload) => {
    return axiosInstance.delete('/users/?user_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/users.js